export class UploadFileModel {
  public fileToUpload: File;
  public filename = '';
  public extern = false;
  public topic: any = { key: '', value: '' };

  public reset(): void {
    this.fileToUpload = null;
    this.filename = '';
    this.extern = false;
    this.topic = { key: '', value: '' };
  }
}
